import { isTouch } from '../../environment/index'

let timer

export function getViewport () {
  const { innerWidth, innerHeight } = global
  if (innerWidth) {
    return {
      unavailable: false,
      touchable: isTouch(),
      height: innerHeight,
      width: innerWidth,
    }
  }
  const { document } = global
  const { documentElement } = document
  const { clientHeight, clientWidth } = documentElement
  return {
    touchable: isTouch(),
    height: clientHeight,
    width: clientWidth,
    ready: false,
  }
}

export function init (onResize) {
  global.addEventListener('resize', () => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      onResize(getViewport())
      clearTimeout(timer)
      timer = null
    }, 400)
  }, false)
}
